import { CommonAction, ValidationData } from '@components/MailpieceActions/types';
import { Piece } from '@rdTypes/apiContract';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type MailpieceActionState = {
  currentAction: CommonAction | null;
  currentMailpiece: Piece | null;
  pendingSearchValue?: string;
  validationData?: ValidationData;
  forceActionsDrawer: {
    open: boolean;
    pieces: Piece[];
    pendingSearchValue?: string;
  };
};

const initialState: MailpieceActionState = {
  currentAction: null,
  currentMailpiece: null,
  pendingSearchValue: undefined,
  validationData: undefined,
  forceActionsDrawer: {
    open: false,
    pieces: [],
    pendingSearchValue: undefined,
  },
};

const mailpieceActionSlice = createSlice({
  name: 'mailpieceAction',
  initialState,
  reducers: {
    startAction: (
      state,
      {
        payload,
      }: PayloadAction<{
        action: CommonAction;
        mailpiece: Piece;
        pendingSearchValue?: string;
        validationData?: ValidationData;
      }>,
    ) => {
      state.currentAction = payload.action;
      state.currentMailpiece = payload.mailpiece;
      state.pendingSearchValue = payload.pendingSearchValue;
      state.validationData = payload.validationData;
    },
    resetAction: (state) => {
      state.currentAction = null;
      state.currentMailpiece = null;
      state.pendingSearchValue = undefined;
      state.validationData = undefined;
    },
    openForceActionsDrawer: (state, { payload }: PayloadAction<{ pieces: Piece[]; pendingSearchValue?: string }>) => {
      state.forceActionsDrawer.open = true;
      state.forceActionsDrawer.pieces = payload.pieces;
      state.forceActionsDrawer.pendingSearchValue = payload.pendingSearchValue;
    },
    closeForceActionsDrawer: (state) => {
      state.forceActionsDrawer.open = false;
      state.forceActionsDrawer.pieces = [];
      state.forceActionsDrawer.pendingSearchValue = undefined;
    },
  },
});

export const { startAction, resetAction, openForceActionsDrawer, closeForceActionsDrawer } =
  mailpieceActionSlice.actions;

export default mailpieceActionSlice.reducer;
